import {
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";

@Component({
  selector: "app-paused-video",
  imports: [SharedModule],
  templateUrl: "./paused-video.component.html",
  styleUrl: "./paused-video.component.scss",
})
export class PausedVideoComponent implements OnInit, OnDestroy {
  @Output() resumeVideo = new EventEmitter<boolean>();

  #router = inject(Router);
  // constructor(private dialogRef: MatDialogRef<PauseVideoComponent>, private router: Router) {}
  // constructor(private router: Router) {}

  ngOnInit(): void {
    document.body.style.overflow = "hidden";
  }
  ngOnDestroy(): void {
    document.body.style.overflow = "auto";
  }

  onResume(): void {
    this.resumeVideo.emit(true);
  }

  onBack(): void {
    this.#router.navigateByUrl("/online-class");
    // this.router.navigateByUrl("/students");
  }
}
